import { getRelativeEpoch } from '@mais-retorno-front/libs/util-helpers';
import { IPeriodDTO, IPeriodType } from './dto';

export class PeriodUseCase {
  private maxStartDate = (periods: IPeriodDTO[]): number => {
    const startDates = periods.map((assetDate) => assetDate.startDate);
    return Math.max(...startDates);
  };

  private minEndDate = (periods: IPeriodDTO[]): number => {
    const endDates = periods.map((assetDate) => assetDate.endDate);
    return Math.min(...endDates);
  };

  calcPeriod = (
    periodType: IPeriodType = 'otimo',
    periods: IPeriodDTO[]
  ): IPeriodDTO => {

    const periodTypeWithoutOldValue = periodType.replace('C:', '');

    const defaultValues = [1, 3, 6, 12, 24, 36, 48]

    if (!isNaN(Number(periodTypeWithoutOldValue)) && !defaultValues.includes(Number(periodTypeWithoutOldValue))) {
      return {
        type: 'months',
        value: periodTypeWithoutOldValue,
        startDate: getRelativeEpoch(
          Number(periodTypeWithoutOldValue),
          this.minEndDate(periods)
        ),
        endDate: this.minEndDate(periods),
      };
    }

    switch (periodTypeWithoutOldValue) {
      case 'otimo':
        return {
          type: 'otimo',
          startDate: this.maxStartDate(periods),
          endDate: this.minEndDate(periods),
        };

      case '1':
        return {
          type: '1',
          startDate: getRelativeEpoch(1, this.minEndDate(periods)),
          endDate: this.minEndDate(periods),
        };

      case '3':
        return {
          type: '3',
          startDate: getRelativeEpoch(3, this.minEndDate(periods)),
          endDate: this.minEndDate(periods),
        };

      case '6':
        return {
          type: '6',
          startDate: getRelativeEpoch(6, this.minEndDate(periods)),
          endDate: this.minEndDate(periods),
        };

      case '12':
        return {
          type: '12',
          startDate: getRelativeEpoch(12, this.minEndDate(periods)),
          endDate: this.minEndDate(periods),
        };

      case '24':
        return {
          type: '24',
          startDate: getRelativeEpoch(24, this.minEndDate(periods)),
          endDate: this.minEndDate(periods),
        };

      case '36':
        return {
          type: '36',
          startDate: getRelativeEpoch(36, this.minEndDate(periods)),
          endDate: this.minEndDate(periods),
        };

      case '48':
        return {
          type: '48',
          startDate: getRelativeEpoch(48, this.minEndDate(periods)),
          endDate: this.minEndDate(periods),
        };


      default: {
        const [startDate, endDate] = periodTypeWithoutOldValue.split('-');

        return { type: 'custom', startDate: Number(startDate), endDate: Number(endDate) };
      }
    }
  };
}
